import * as React from "react";
import {Box} from "@unibuddy/patron";

type ErrorProps = {
    error?: string;
};

export const ErrorMessage: React.FC<ErrorProps> = React.memo((props: ErrorProps) => {
    if (!props.error) {
        return null;
    }
    return (
        <Box display="block">
            <Box
                display="inline-block"
                paddingX="xsmall"
                paddingY="xxsmall"
                borderRadius="xxsmall"
                color="#a50000"
                backgroundColor="#ffc1c1"
                style={{fontSize: "0.875rem"}}
            >
                {props.error}
            </Box>
        </Box>
    );
});
ErrorMessage.displayName = "ErrorMessage";
